import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { LocatorQuickSearch } from "../LocatorQuickSearch";

type IProps = Immutable<templates.LocatorQuickSearchTemplate>;

export const LocatorQuickSearchSSR = (props: IProps): React.JSX.Element => {
    return (
        <LocatorQuickSearch
            selectedItem={props.selected_item}
            hideElite={props.hide_elite}
            hideTpStores={props.hide_tp_stores}
        />
    );
};
